import AngleLeftSvg from "@icons/angle-left.svg?react";
import CrossSvg from "@icons/cross.svg?react";

import { useSidebar } from "@/common/providers/sidebar-provider/sidebar-provider";
import { FullscreenModalLayout } from "@/routes/layout/layout.fullscreen";

import { Overview } from "./overview";
import { Failure, SubscriptionCancel } from "./subscription.cancel";
import { SubscriptionDetail } from "./subscription.detail";
import { SubscriptionOverview } from "./subscription.overview";

const Subscriptions = () => {
  const sidebar = useSidebar();
  let Jsx: Record<"component" | "button", React.ReactNode> = {
    button: null,
    component: null,
  };

  if (sidebar.state.screen === "subscriptions") {
    Jsx = {
      button: <CrossSvg />,
      component: <Overview />,
    };
  } else if (sidebar.state.screen === "subscriptions-overview") {
    Jsx = {
      button: <CrossSvg />,
      component: <SubscriptionOverview />,
    };
  } else if (sidebar.state.screen === "subscriptions-detail") {
    Jsx = {
      button: <AngleLeftSvg />,
      component: <SubscriptionDetail />,
    };
  } else if (sidebar.state.screen === "subscriptions-cancel") {
    Jsx = {
      button: <AngleLeftSvg />,
      component: <SubscriptionCancel />,
    };
  } else if (sidebar.state.screen === "subscriptions-cancel-failure") {
    Jsx = {
      button: <CrossSvg />,
      component: <Failure />,
    };
  }

  return (
    <FullscreenModalLayout
      headerButton={
        <button onClick={sidebar.actions.executeCloseAction}>
          {Jsx.button}
        </button>
      }
    >
      {Jsx.component}
    </FullscreenModalLayout>
  );
};

export { Subscriptions };
